<!--
  ~ Copyright (C) 2025 DV Bern AG, Switzerland
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as
  ~ published by the Free Software Foundation, either version 3 of the
  ~ License, or (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->
<div class="tooltip-wrapper">
    <div class="ugly-button-row">
        <button (click)="close()"><i class="fa fa-times"></i></button>
    </div>
    <div class="tooltip-panel">
        <div
            class="text-content"
            [innerHTML]="dialogData.text | translate"
        ></div>
        <button class="dv-btn" (click)="close()">
            {{ 'ZURUECK_ONLY' | translate }}
        </button>
    </div>
</div>
